import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { AuthHeaders } from '../../../models/auth-headers';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { authwsEnvironment } from '../authws-environment';
import { accountApplicationSchema } from '../schemas/account-application.schema';

/**
 * Get a list of applications and their settings for an account
 * @param accountAlias account alias
 * @returns array of applications and their settings for an account
 */
export function getAccountsApplicationlist(
  this: unknown,
  accountAlias: string
) {
  const params = new URLSearchParams([['accountAlias', accountAlias]]);

  return fromFetch(
    new Request(
      `${
        authwsEnvironment.resolve(this).accountsApplicationListUrl
      }?${params.toString()}`,
      {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...new AuthHeaders(),
        },
      }
    )
  ).pipe(selectData(z.array(accountApplicationSchema)));
}
